import { SocialSecurityTile } from "../../components/dashboard/SocialSecurityTile.js";
import { SuggestedPromptsTile } from "../../components/SuggestedPromptsTile.js";
import { PAGE_PROMPTS } from "../../lib/data/page-prompts.js";
import { useDocumentTitle } from "../../lib/util/use-document-title.js";
import { FireSubPageLayout } from "./_layout.js";
import { useFireContext } from "./_use-fire-context.js";

/**
 * /fire/social-security — Phase 13.5 extraction.
 *
 * Estimated SS benefit at 62 / FRA / 70 against the user's PIA, and
 * how the chosen claim age shifts the FI target.
 */
export function FireSocialSecurityPage() {
  useDocumentTitle("FIRE — Social Security");
  const { hideValues, fiAssetsCents } = useFireContext();
  return (
    <FireSubPageLayout
      title="Social Security"
      sub="Estimated benefit by claim age and the bridge it provides against your FI target."
    >
      <SocialSecurityTile
        hideValues={hideValues}
        fiAssetsCents={fiAssetsCents}
      />
      <SuggestedPromptsTile prompts={PAGE_PROMPTS.fireSocialSecurity} />
    </FireSubPageLayout>
  );
}
